import { getSearchParamsString } from '@reapitform/utils'
import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { IDefaultSpecialTerms, IPaginationParams, IResponseWithPagination } from '../../types'
import { useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'

export const useDefaultSpecialCondition = (params: IPaginationParams) => {
  const queryClient = useQueryClient()

  const searchParams = getSearchParamsString(params)
  const path: string = `/api/Organization/DefaultSpecialCondition${searchParams}`
  const [result, loading, errorString] = usePlatformGet<IResponseWithPagination<IDefaultSpecialTerms>>({
    path,
    retry: false,
  })

  const queryKey = useMemo(getUrl(path), [path])

  const { _embedded, ...pagination } = result ?? {}

  const updateCacheData = (
    data: IDefaultSpecialTerms[] | ((preData: IDefaultSpecialTerms[]) => IDefaultSpecialTerms[]),
  ) => {
    if (!queryClient) return

    queryClient.setQueryData([queryKey], (prevData: IResponseWithPagination<IDefaultSpecialTerms>) => {
      let newValue = data
      if (typeof data === 'function') newValue = data(prevData._embedded)

      return { ...prevData, _embedded: newValue }
    })

    queryClient.invalidateQueries({ queryKey: [queryKey] })
  }

  return { data: _embedded, pagination: pagination, loading, errorString, updateCacheData }
}
